import axios from 'axios';
import dateFormat = require('dateformat');
import { createContext } from 'react';
import { Component } from '@wordpress/element';
import { Filters } from './filters';
import { Export } from './export';
import { Results } from './results';

interface AppProps {
    wpProps: wpProps
}

export const AppContext = createContext<any>({})

// @ts-ignore
const { pbcFacetSettings } = window;

export default class App extends Component<AppProps> {

    multiLoad = false;
    state = {
        searching: true,
        total: 0,
        total_pages: 0,
        orderBy: 'date-desc',
        results: [] as Array<wpPost>,
        criteria: this.props.wpProps.filters,
        stopScrollEvents: false,
        current_page: 1,
        terms: {},
    }
    api = axios.create({
        baseURL: this.props.wpProps.root,
        headers: {'X-WP-Nonce': this.props.wpProps.nonce}
    });

    init = () => {

        const storage = this.loadFromStorage();
        const search = window.location.search.replace('?keywords=', '');
        let { criteria, current_page } = this.state;

        if (!storage) {
            current_page = 1;
            criteria.forEach((filter, index) => {
                if (filter.type === 'text') {
                    criteria[index].data = {
                        text: search,
                        submit: search !== ''
                    };
                    window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
                } else if (filter.type === 'date') {
                    criteria[index].date = {
                        from: null,
                        to: null
                    };
                } else if (filter.type === 'tax') {
                    criteria[index].terms = criteria[index].terms.map(term => {
                        term.checked = term.taxonomy === 'status_tax' ? true : false;
                        return term;
                    });
                }
            });
        } else {
            const { data } = storage;
            current_page = storage.currentPage;
            if (current_page > 1) this.multiLoad = true;

            if (!!search) {
                const i = data.findIndex((filter: filter) => filter.type === 'text');
                data[i].data.text = search;
                data[i].data.submit = true;
                window.history.replaceState({}, document.title, window.location.origin + window.location.pathname);
            }

            criteria.forEach((filter, index) => {
                if (filter.type === 'text') {
                    criteria[index] = data[index];
                } else if (filter.type === 'date') {
                    const { from, to } = data[index].date;
                    criteria[index].date = {
                        from: from ? new Date(from) : null,
                        to: to ? new Date(to) : null
                    }
                } else {
                    criteria[index].terms = criteria[index].terms.map((term, i) => {
                        const storageTerm = data[index].terms[i];
                        if (storageTerm) term.checked = storageTerm.checked;
                        return term;
                    });
                }
            });
        }

        // Get a list of terms indexed by taxonomy name and term ID.
        const terms = criteria.reduce( (termsAcc: TaxonomiesList, criteriaItem: filter ) => {
            const { terms, name, type } = criteriaItem;
            if ( type !== 'tax' || terms.length === 0 ) {
                return termsAcc;
            }

            const { taxonomy } = terms[0];
            termsAcc[ taxonomy ] = terms.reduce( ( taxTermsAcc: TermsList, term: term ) => {
                const { term_id, name } = term;
                taxTermsAcc[ term_id ] = term;
                return taxTermsAcc;
            }, {} );

            return termsAcc;
        }, {} );

        this.setState({ terms, criteria, current_page }, this.query);
    }

    loadFromStorage = () => {
        if (window.localStorage !== undefined) {
            const { post_type } = this.props.wpProps;

            const timeNow = Math.round(new Date().getTime() / 1000);
            const storage = JSON.parse(localStorage.getItem(`${post_type}-search-cache`));

            if (!!storage) {
                if (timeNow < parseInt(storage.expiration)) {
                    return storage;
                } else {
                    this.removeLocalStorage();
                    return null;
                }
            }
            return null;
        } else {
            return null;
        }
    }

    saveToStorage = () => {
        if (window.localStorage !== undefined) {
            const { post_type } = this.props.wpProps;
            const { criteria, current_page } = this.state;

            const storage = {
                data: criteria,
                expiration: Math.round(new Date().getTime() / 1000) + (24 * 3600),
                currentPage: current_page
            }

            localStorage.setItem(`${post_type}-search-cache`, JSON.stringify(storage));
        }
    }

    removeLocalStorage = () => {
        if (window.localStorage !== undefined) {
            const { post_type } = this.props.wpProps;
            localStorage.removeItem(`${post_type}-search-cache`);
        }
    }

    getTermIDs = (terms: Array<term>) => terms.filter(term => term.checked).map(term => term.term_id).join(',');

    query = async () => {
        const { current_page } = this.state;
        this.setState({searching: true});

        if (!this.multiLoad) {
            const response = await this.api.get(this.queryUrl());
            if (response.status === 200) {
                this.setState({
                    total: parseInt(response.headers['x-wp-total']),
                    total_pages: parseInt(response.headers['x-wp-totalpages']),
                    results: current_page > 1 ? this.state.results.concat(response.data) : response.data,
                    stopScrollEvents: false,
                    searching: false
                },
                this.saveToStorage);
            } else {
                this.setState({searching: false, stopScrollEvents: false});
                console.log(response);
            }
        } else {
            for (let i = 0; i < current_page; i++) {
                const response = await this.api.get(this.queryUrl(i + 1));
                if (response.status === 200) {
                    this.setState({
                        total: parseInt(response.headers['x-wp-total']),
                        total_pages: parseInt(response.headers['x-wp-totalpages']),
                        results: this.state.results.concat(response.data),
                    });
                } else {
                    console.log(response);
                    break;
                }
            }
            this.multiLoad = false;
            this.setState({searching: false, stopScrollEvents: false}, this.saveToStorage);
        }
    }

    queryUrl = (overwriteCurrentPage: number = null) => {

        const { per_page, post_type, sort_deals_by } = this.props.wpProps;
        const { criteria, current_page, orderBy } = this.state;

        let query_string = `?per_page=${per_page}&pbc_facet_context=true`;
        let fragment = '';
        let isKeyWordsEmpty = false;
        criteria.forEach(filter => {

            if (filter.type == "tax") {

                const IDs = this.getTermIDs(filter.terms);
                if (IDs) {
                    let tax = filter.name;
                    if (tax === 'status') {
                        tax = 'status_tax';
                    } else if (tax === 'type of deal') {
                        tax = 'deal_type';
                    }
                    fragment = `${tax}=${IDs}`;
                }

            } else if (filter.type == "text" ) {

                if ( !!filter.data.text ) {
                    fragment = `search=${filter.data.text}`;
                }
                else {
                    isKeyWordsEmpty = true;
                }

            } else if (filter.type == "date") {

                fragment = '';

                Object.keys(filter.date).forEach(key => {
                    const val = filter.date[key];

                    if (val) {
                        let formattedDate = dateFormat(val, "isoUtcDateTime");

                        if (fragment != ""){
                            fragment += "&"
                        }
                        fragment += `${key === 'from' ? 'after' : 'before'}=${formattedDate}`;
                    }
                });
            }

            if (query_string === '') {
                query_string = `?${fragment}`;
            } else if(!query_string.includes(fragment)) {
                query_string += `&${fragment}`
            }
        });

		// Only request the fields we need, for performance.
		// (Skips processing Yoast information, etcetera.)
		query_string += `&_fields=${ [
			'id',
			'excerpt',
			'featured_media',
			'fimg_url',
			'formatted_date',
			'link',
			'primary_category_name',
			'search_thumbnail',
			'title',
			'writers',
		].join( ',' ) }`;

        switch (orderBy){
            case "az": query_string += "&orderby=title&order=asc"; break;
            case "za": query_string += "&orderby=title&order=desc"; break;
            case "date-asc": query_string += `&orderby=${post_type == 'deal' ? sort_deals_by : 'date'}&order=asc`; break;
            case "date-desc": query_string += `&orderby=${post_type == 'deal' ? sort_deals_by : 'date'}&order=desc`; break;
            case "relevance": {
                // Force date ordering if keyword is empty
                query_string += isKeyWordsEmpty ? '&orderby=date&order=desc' : '&orderby=relevance&order=desc'
                break;
            }
        }

        const currentPage = overwriteCurrentPage ? overwriteCurrentPage : current_page;
        const url = `/wp/v2/${post_type}/${query_string}${currentPage > 1 ? `&page=${currentPage}` : ''}`;
        // console.log('url = ', url);
        return url;
    }

    componentWillMount() {
        this.init();
    }

    render() {
        const { post_type } = this.props.wpProps;
        const { terms } = this.state;
        return (
            <div className={`pbc-facet-search pbc-facet-search--${post_type}` } >
                <div className={`pbc-facet-search__overlay${this.state.searching && ' searching'}`}>
                    <AppContext.Provider value={this}>
                        <Filters/>
                        {
                            pbcFacetSettings.canExport && <Export
                              getQueryURL={ this.queryUrl }
                              terms={ terms }
                            />
                        }
                        <Results/>
                    </AppContext.Provider>
                </div>
            </div>
        )
    }
}
